import { Typography, Link, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import LogoIconeLight from "../../../images/LogoIconeLight.png";
import LogoIconeDark from "../../../images/LogoIconeDark.png";

export function HeaderLogin() {
  const theme = useTheme();
  const logoSrc =
    theme.palette.mode === "dark" ? LogoIconeDark : LogoIconeLight;

  return (
    <Box component="div" noValidate align="center">
      <Box
        component="img"
        src={logoSrc}
        alt="Logo KronOS"
        sx={{
          width: 230,
          height: 230,
          objectFit: "contain",
        }}
      />
      <Typography
        variant="h2"
        fontWeight="bold"
        sx={{
          mb: 2,
          fontFamily: "'Audiowide', cursive",
          letterSpacing: 2,
          color: "primary.main",
        }}
      >
        Padel Rank
      </Typography>

      <Typography>Por favor digite seu usuário e senha!</Typography>
    </Box>
  );
}

export function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © CODX "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
